import React, {Component, Fragment} from 'react';
import _ from 'lodash';

import { Card, CardBody, CardHeader, Collapse, FormGroup, Input, Label} from "reactstrap";
import qs from "qs";
import {withRouter} from "react-router-dom";

import CollapseButton from '../dumb/collapseButton';

class DatasetFilter extends Component {

    constructor(props){
        super(props);
        this.renderDatasetCheckboxes = this.renderDatasetCheckboxes.bind(this);
        this.toggleCheckbox = this.toggleCheckbox.bind(this);
        this.updateAPIURL = this.updateAPIURL.bind(this);
        this.processResponse = this.processResponse.bind(this);
        this.toggleCollapse = this.toggleCollapse.bind(this);

        const fields = ["mutations", "cnv", "expression", "methylation", "drugs", "crispr_ko", "fusions", "proteomics"];

        const current_qs = qs.parse(window.location.search, { ignoreQueryPrefix: true });

        this.state = {
            fields,
            isOpen: false,
            activeCount: 0,
            filters: DatasetFilter.getFiltersFromQS(
                current_qs,
                _.reduce(fields, (res, field) => {
                    res[field] = {active: false, count: 0};
                    return res;
                }, {})
            )
        };

        this.aggregates = _.reduce(this.state.fields, (res, field) => {res[`${field}_available`] = 'count'; return res}, {})
    }

    /*
     * Get the selected dataset filters from the URL.
     * Builds a NEW filters object rather than mutating oldfilters in place.
     */
    static getFiltersFromQS(qsObj, oldfilters){
        const activeFilters = DatasetFilter.getActiveFiltersFromQS(qsObj, 'datasets');

        return _.reduce(oldfilters, (res, filterProps, field) => {
            res[field] = {
                ...filterProps,
                active: activeFilters.indexOf(field) >= 0
            };
            return res;
        }, {});
    }

    static getDerivedStateFromProps(newprops, oldstate){
        let querystring = qs.parse(newprops.location.search, { ignoreQueryPrefix: true });

        const newfilters = DatasetFilter.getFiltersFromQS(querystring, oldstate.filters);

        return {
            filters: newfilters,
            activeCount: _.filter(newfilters, 'active').length
        }
    }

    static getActiveFiltersFromQS(qs_obj, field, defaultValue = [], sep="__"){
        return (field in qs_obj)? _.split(_.get(qs_obj, field), sep):defaultValue;
    }

    updateAPIURL(api_qs, newlistprops){
        let new_qs = qs.parse(newlistprops.location.search, { ignoreQueryPrefix: true });
        let activeDatasetFilters = DatasetFilter.getActiveFiltersFromQS(new_qs, 'datasets');
        if(activeDatasetFilters.length > 0){
            for(let dataset of activeDatasetFilters){
                let filter_qs = {"name":`${dataset}_available`,"op":"eq","val":true};
                api_qs.filter = _.get(api_qs, 'filter', []).concat(filter_qs)
            }
        }
        return _.merge(api_qs, {agg: this.aggregates})
    }

    getFromResponse(resp, field){
        let basePath = `meta.agg.${field}_available`;
        return _.get(resp, basePath + ".true") || _.get(resp, basePath + ".count.True")
    }

    /*
     * Build a NEW filters object each time rather than mutating
     * this.state.filters[field] in place via _.merge.
     */
    processResponse(response){
        let newfilters = _.reduce(this.state.fields, (res, field) => {
            res[field] = {
                ...this.state.filters[field],
                count: this.getFromResponse(response, field)
            };
            return res
        }, {});
        this.setState({
            filters: newfilters
        })
    }

    toggleCollapse(){
        this.setState({isOpen: !this.state.isOpen})
    }

    toggleCheckbox(event){
        let dataset = event.target.name;
        let current_qs = qs.parse(window.location.search, { ignoreQueryPrefix: true });
        let currentlyActiveDatasets = ('datasets' in current_qs)? _.split(current_qs.datasets, "__"):[];

        if(event.target.checked){
            currentlyActiveDatasets.push(dataset)
        } else {
            currentlyActiveDatasets = currentlyActiveDatasets.filter((item) => item !== dataset)
        }
        current_qs.datasets = (currentlyActiveDatasets.length > 0)? _.join(currentlyActiveDatasets.sort(), "__"): undefined;
        current_qs.page = undefined;
        this.props.history.push(window.location.pathname + qs.stringify(current_qs, { addQueryPrefix: true }))
    }

    renderDatasetCheckboxes(){
        let active = [];
        let inactive = [];

        _.map(_.toPairs(this.state.filters), ([dataset, details]) => {
            const cb = (
                <FormGroup check key={dataset}>
                    <Input type="checkbox" name={dataset} onChange={this.toggleCheckbox} checked={_.get(details, 'active')}/>{' '}
                    <Label className="ml-4 mt-1" check>
                        {dataset.replace(/crispr_ko/g, "crispr_dependencies")} <span className="secondary">({_.get(details, 'count')})</span>
                    </Label>
                </FormGroup>
            );

            if (details.active) {
                active.push(cb);
            } else {
                inactive.push(cb);
            }
        });

        // Show active filters first, followed by enough inactive
        // filters to make five visible - matches AlcoholFilter/MalignancyFilter.
        if (active.length < 5 && active.length + inactive.length > 0) {
            active = active.concat(inactive.splice(0, 5 - active.length));
        }

        return (
            <Fragment>
                {active}
                {inactive}
            </Fragment>
        );
    }

    componentDidMount() {
        this.props.registerResponse(this.processResponse);
        this.props.registerRequest(this.updateAPIURL);
    };

    componentWillUnmount() {
        this.props.unregisterResponse(this.processResponse);
        this.props.unregisterRequest(this.updateAPIURL);
    };

    render(){
        return(
            <Card className="genetic-filters mb-2 z0 hover">
                <CardHeader className="justify-content-between d-flex" onClick={this.toggleCollapse} >
                    <div className="d-inline w-50">Dataset Availability</div>
                    <div className="d-inline-block">
                        {this.state.activeCount > 0 && (<strong>{this.state.activeCount + ' active'}</strong>)}
                    </div>
                    <CollapseButton isOpen={this.state.isOpen} onClick={this.toggleCollapse} />
                </CardHeader>
                <Collapse isOpen={this.state.isOpen}>
                    <CardBody>
                        <span className="small">Only show models that have following datasets available</span>
                        {this.renderDatasetCheckboxes()}
                    </CardBody>
                </Collapse>
            </Card>
        )
    }
}

export default withRouter(DatasetFilter)